import { eventsKeys } from '../constants';
import send from './send';

export default ({ questionId }) => {
  send(eventsKeys.QUICK_SIGNUP_STARTED, {
    questionId,
  });
};
